import { evalQueries } from '@/entities/eval'
import useEvaluationStore from '@/entities/eval/model/eval-stnt.store'
import { EvalInfoTable } from '@/widgets/eval'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { useRouter } from '@tanstack/react-router'
import { usePersistStore } from '@/shared/lib/store'

import { useLoginStore } from '@/shared/lib/store/model/login.store'
import { initTokenManager } from '@/shared/utils/wait-for-token'
export const Route = createFileRoute('/eval/Ready')({
  component: RouteComponent,
})

function RouteComponent() {
  const { setNickNameToken } = useLoginStore()
  const { publishInfo, sUserId } = useEvaluationStore.getState()
  const [evlId, setEvlId] = useState(publishInfo.trgtId)
  const [publishId, setPublishId] = useState(publishInfo.publishId)
  const [userId, setUserId] = useState(sUserId)
  const router = useRouter()
  const evalUserInfo = sessionStorage.getItem('evalUserInfo')
  const [data, setData] = useState<any>()
  const { refetch } = evalQueries.getEvalInfo({
    evlId: evlId,
    userId: userId,
  })

  const getPersistStore = () => {
    const persistState = usePersistStore.getState()
    return persistState
  }

  useEffect(() => {
    const fetchData = async () => {
      const { data: newData } = await refetch()
      setData(newData)
    }

    if (evlId == 0 || userId == '') return
    else {
      fetchData()
    }
  }, [evlId, userId])

  useEffect(() => {
    async function fetchAndSetUser() {
      await setNickNameToken(sUserId)
    }
    fetchAndSetUser()
  }, [sUserId])

  useEffect(() => {
    initTokenManager()
    if (evalUserInfo) {
      const parsedInfo = JSON.parse(evalUserInfo)
      setEvlId(parsedInfo.evlId)
      setUserId(parsedInfo.userId)
      setPublishId(parsedInfo.publishId)

      useEvaluationStore.setState({
        sUserId: parsedInfo.userId,
      })
    } else {
      router.history.go(-1)
    }
  }, [])

  return (
    data && (
      <EvalInfoTable data={data ?? {}} showBtn={true} publishId={publishId} />
    )
  )
}
